import Lottie from 'react-lottie-player';
import lottieJson from "../../../../src/pages/about-us/Produk.json";
import * as React from 'react';
export default {
  Lottie,
  lottieJson,
  React
};